import httpClient from "@/_shared/http-client";
import store from "@/_shared/store";
import { date } from "@/_shared/utils";
import { generators } from "@/authorization/utils";

const checkExistence = async (login = "") => {
  const fullUrl = new URL("/api/auth/existence", process.env.BACKEND_URL);
  fullUrl.searchParams.set("login", login);
  const response = await httpClient.get(fullUrl);
  return response;
};

const login = async (user = {}, password = null, snapshot = null) => {
  const fullUrl = new URL("/api/auth/login", process.env.BACKEND_URL);
  fullUrl.searchParams.set("by_password", !!password);
  if (password) {
    user.password = password;
  }
  const biometricForm = _prepareBiometricForm(user, snapshot);
  const passwordForm = _preparePasswordForm(user);
  const sendingData = password ? passwordForm : biometricForm;
  sendingData.user.authorized_at = date.getIsoString();
  const response = await httpClient
    .post(fullUrl, sendingData)
    .then((response) => {
      const { token, logged_today } = response.data;
      store.commit('setRole', null);
      localStorage.setItem("token", token);
      return logged_today;
    });
  return response;
};

const addFailure = async (data = {}) => {
  const { user, snapshot, failure_reason } = data;
  const biometricForm = _prepareBiometricForm(user, snapshot);
  biometricForm.failure_reason = failure_reason;

  let results = null;
  const url = `${process.env.BACKEND_URL}/auth/failure`;
  await httpClient.post(url, biometricForm).then((response) => {
    results = response.data;
  });
  return results;
};

const _prepareBiometricForm = (user, snapshot) => ({
  user,
  image: {
    content: snapshot,
    name: generators.generateSnapshotName(user),
  },
  created_at: date.getIsoString(),
});

const _preparePasswordForm = (user) => ({
  user,
  created_at: date.getIsoString(),
});

const apiService = {
  login,
  checkExistence,
  addFailure,
};

export default apiService;



// WEBPACK FOOTER //
// ./src/authorization/apiService.js